"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCaptureType = void 0;
/**
 * The types of images used by the form
 */
exports.IkeCaptureType = {
    /**
     * Generic image with no sensor data required.
     * Similar to how a smart phone would take a image
     * */
    IMAGE: 'image',
    /**
     * Calibrated image taken with a IKE Device
     *
     * This image has a lot of sensor data with it, location, IMU, GPS etc.
     */
    TRUE_SIZE: 'truesize'
};
//# sourceMappingURL=capture.type.js.map